import { useEffect, useState } from "react";
import { getSession } from "./api/client";
import { LoginScreen } from "./components/LoginScreen";
import { MainScreen } from "./components/MainScreen";
import { SettingsScreen } from "./components/SettingsScreen";
import { useSettings } from "./hooks/useSettings";

type View = "main" | "settings";

export default function App() {
  const [authenticated, setAuthenticated] = useState<boolean | null>(null);
  const [view, setView] = useState<View>("main");
  const { settings, updateSettings } = useSettings();

  useEffect(() => {
    getSession()
      .then((data) => setAuthenticated(data.authenticated))
      .catch(() => setAuthenticated(false));
  }, []);

  if (authenticated === null) {
    return (
      <div className="screen loading-screen">
        <div className="brand">J.A.R.V.I.S</div>
      </div>
    );
  }

  if (!authenticated) {
    return <LoginScreen onSuccess={() => setAuthenticated(true)} />;
  }

  if (view === "settings") {
    return (
      <SettingsScreen
        settings={settings}
        onUpdateSettings={updateSettings}
        onBack={() => setView("main")}
        onLoggedOut={() => {
          setAuthenticated(false);
          setView("main");
        }}
      />
    );
  }

  return <MainScreen settings={settings} onOpenSettings={() => setView("settings")} />;
}
